import * as React from 'react';
import { useAnchorPositioning } from '../../utils/useAnchorPositioning.js';
import { useTooltipRootContext } from '../root/TooltipRootContext.js';
export function useTooltipPositioner(params) {
  const {
    open,
    trackCursorAxis,
    mounted
  } = useTooltipRootContext();
  const positioning = useAnchorPositioning(params);
  const props = React.useMemo(() => {
    const hiddenStyles = {};
    if (!open || trackCursorAxis === 'both') {
      hiddenStyles.pointerEvents = 'none';
    }
    return {
      role: 'presentation',
      hidden: !mounted,
      style: {
        ...positioning.positionerStyles,
        ...hiddenStyles
      }
    };
  }, [open, trackCursorAxis, mounted, positioning.positionerStyles]);
  return React.useMemo(() => ({
    props,
    ...positioning
  }), [props, positioning]);
}